import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import echarts from 'echarts'
// import 'element-ui/lib/theme-chalk/index.css'

import '../static/css/index.css'
import '../static/css/fonts.css'
import Enlocale from '../node_modules/element-ui/lib/locale/lang/en'
import Zhlocale from '../node_modules/element-ui/lib/locale/lang/zh-CN'
import router from './router/index.js'

import axios from 'axios'
import qs from 'qs'

import store from './store/index'
window.sessionStorage.setItem('webInfo', 'ASOS')


router.beforeEach((to, from, next) => {
  if (to.path.split('/')[1] == 'releaseManagement') {
    Vue.use(ElementUI, { locale: Zhlocale })
  } else {
    Vue.use(ElementUI, { locale: Enlocale })
  }
  next()
})
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js